import { z } from 'zod';
// Consumer-owned duplicate of Knowledge's minimized published-artifact wire contract.
// Training does not import Knowledge code, persistence, or content bodies.
export const trainingKnowledgePublishedReferenceCapability = 'training.knowledge-published-reference.v1';
export const trainingKnowledgePublishedArtifactCapability = 'knowledge.published-artifact.v1';
export const trainingKnowledgePublishedArtifactSlot = 'knowledge.published-artifact';
export const trainingKnowledgePublishedArtifactProviderId = 'knowledge.server.published-artifact';
export const trainingKnowledgePublishedArtifactRequestSchema = z.strictObject({
    consumerModuleId: z.literal('training'),
    requestedCapability: z.literal(trainingKnowledgePublishedReferenceCapability),
    resourceType: z.literal('training.course-release-citation'),
    resourceId: z.string().uuid(),
    documentId: z.string().uuid(),
});
export const trainingKnowledgePublishedArtifactSnapshotSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(trainingKnowledgePublishedArtifactCapability),
    documentId: z.string().uuid(),
    versionId: z.string().uuid(),
    versionNumber: z.number().int().positive(),
    title: z.string().trim().min(1).max(200),
    documentType: z.enum(['sop', 'policy', 'safety', 'reference', 'faq', 'guide']),
    requiresAcknowledgement: z.boolean(),
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    publishedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=training-knowledge-published-artifact.contract.js.map